import axios from "axios";
import moment from "moment/moment";

const TIMEOUT = 90000;
const checkIdentificationStatusUrl = process.env.REACT_APP_HEYCAR_IDENTITY_URL;

/**
 *
 * @param id {string}
 * @returns {Promise<{status:string}> | never>}
 */
const checkStatus = (id) =>
  axios
    .get(`${checkIdentificationStatusUrl}${id}?rand=${moment().unix()}`, {
      headers: {
        "Cache-Control": "no-cache, no-store",
        Pragma: "no-cache",
      },
      validateStatus: (status) => status === 200,
      timeout: TIMEOUT,
    })
    .then((response) => response.data);

export { checkStatus };
